'use client';

import React, { useState } from 'react';
import Image, { type ImageLoaderProps } from 'next/image';
import { cn } from '../../lib/utils';

interface ProjectImageProps {
  src: string;
  alt: string;
  priority?: boolean;
  className?: string;
}

// Bypass @unpic/react's Supabase CDN auto-detection — it rewrites object URLs
// to /storage/v1/render/image/public/...?width=N, which 403s without the
// Image Transformation add-on.
const passthroughLoader = ({ src }: ImageLoaderProps) => src;

export function ProjectImage({ src, alt, priority = false, className }: ProjectImageProps) {
  const [loading, setLoading] = useState(true);

  return (
    <div className="relative w-full h-full">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-secondary/30">
          <div className="w-10 h-10 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
        </div>
      )}
      <Image
        src={src}
        alt={alt}
        fill
        className={cn(
          "object-cover",
          loading ? "opacity-0" : "opacity-100 transition-opacity duration-500",
          className
        )}
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1200px"
        onLoad={() => setLoading(false)}
        priority={priority}
        loader={passthroughLoader}
      />
    </div>
  );
}